import {
  ExchangeAvailabilityMap,
  ExchangeCode,
} from "@/lib/market-data/market-data.types";
import { ensureUsdtSymbol } from "@/utils/symbols";

export const CANDLE_EXCHANGE_PRIORITY: ExchangeCode[] = [
  "binance",
  "bybit",
  "asterdex",
  "hyperliquid",
  "gate",
  "kucoin",
];

export function pickAvailableCandleExchange(
  availability: ExchangeAvailabilityMap,
  preferred: ExchangeCode
): ExchangeCode | null {
  if (availability[preferred]?.available) return preferred;
  return (
    CANDLE_EXCHANGE_PRIORITY.find((code) => availability[code]?.available) ??
    null
  );
}

const KUCOIN_BASE_ALIASES: Record<string, string> = {
  BTC: "XBT",
};

export function normalizeCandleSymbol(
  exchange: ExchangeCode,
  symbol: string
): string {
  const upperRaw = symbol.toUpperCase().replace("/", "").trim();

  if (exchange === "gate" && upperRaw.includes("_")) {
    return upperRaw;
  }
  if (exchange === "kucoin" && upperRaw.endsWith("USDTM")) {
    return upperRaw;
  }
  if (exchange === "hyperliquid" && !upperRaw.includes("USDT")) {
    return upperRaw;
  }

  const normalized = ensureUsdtSymbol(symbol);

  switch (exchange) {
    case "gate":
      return normalized.replace("USDT", "_USDT");
    case "kucoin": {
      const base = normalized.replace("USDT", "");
      const aliased = KUCOIN_BASE_ALIASES[base] ?? base;
      return `${aliased}USDTM`;
    }
    case "hyperliquid":
      return normalized.replace("USDT", "");
    case "binance":
    case "bybit":
    case "asterdex":
    default:
      return normalized;
  }
}

export function mapExchangeToSupportedCode(
  exchangeCode?: string | null
): ExchangeCode {
  const lower = (exchangeCode ?? "").toLowerCase();
  if (lower.includes("bybit")) return "bybit";
  if (lower.includes("gate")) return "gate";
  if (lower.includes("kucoin")) return "kucoin";
  if (lower.includes("hyperliquid")) return "hyperliquid";
  if (lower.includes("aster")) return "asterdex";
  return "binance";
}

